var _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8327 14.5H6.16602",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8327 19.5H6.16602",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8327 24.5H6.16602",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8336 7.83317L16.167 1.1665H3.66699C3.00395 1.1665 2.36807 1.4299 1.89922 1.89874C1.43038 2.36758 1.16699 3.00346 1.16699 3.6665V30.3332C1.16699 30.9962 1.43038 31.6321 1.89922 32.1009C2.36807 32.5698 3.00395 32.8332 3.66699 32.8332H20.3337C20.9967 32.8332 21.6326 32.5698 22.1014 32.1009C22.5703 31.6321 22.8336 30.9962 22.8336 30.3332V7.83317Z",
    stroke: "#333333",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.167 1.2146V7.83335H22.8336",
    stroke: "#333333",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8333 16.6667C28.8333 20.0724 26.0724 22.8333 22.6667 22.8333C19.2609 22.8333 16.5 20.0724 16.5 16.6667C16.5 13.2609 19.2609 10.5 22.6667 10.5C26.0724 10.5 28.8333 13.2609 28.8333 16.6667Z",
    fill: "white",
    stroke: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 21.6396,
    width: 1,
    height: 10.6667,
    transform: "rotate(-39.7729 26 21.6396)",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.ffbb328e035e6e45fd7c3b53a148e735.svg";
export { ForwardRef as ReactComponent };